import React from 'react'
// libs
import { useMutation, useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { API_TOKENS_LIST } from 'graphql/apiToken/queries'
import { CREATE_API_TOKEN } from 'graphql/apiToken/mutations'
// types
import { TRefetch } from 'types/refetch'
import { IApiTokensResponse, IApiTokensQueryArgs, IApiToken } from 'types/graphql'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  data: IApiToken[]
  refetch: TRefetch<IApiTokensResponse, IApiTokensQueryArgs>
  isLoading: boolean
  totalCount: number
  createApiToken: () => Promise<void>
}

export const ApiTokensPageContext = React.createContext<IContext>({} as any)

const ApiTokensPageAPI: React.FC<Props> = ({ children }) => {
  const { page, perPage } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery(API_TOKENS_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const [createApiTokenMutation] = useMutation(CREATE_API_TOKEN)

  const apiTokens = get(data, 'apiTokens.data', [])
  const totalCount = get(data, 'apiTokens.pagination.totalCount')

  const createApiToken = async () => {
    try {
      await createApiTokenMutation()
      await refetch()
    } catch (error) {
      console.log('ApiTokensPageAPI.createApiToken: ', error)
    }
  }

  const value = {
    refetch,
    totalCount,
    createApiToken,
    data: apiTokens,
    isLoading: networkStatus === 1
  }

  return <ApiTokensPageContext.Provider value={value}>{children}</ApiTokensPageContext.Provider>
}

export default ApiTokensPageAPI
